import {
  Component,
  effect,
  HostListener,
  inject,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { CardComponent } from "../card/card.component";
import { ScreenSizeService } from "../../../core/services/screen-size.service";
import { CommonModule } from "@angular/common";
import { CONSULTANCY_CARD_ARRAY } from "../../../constants/constants";
import { ContactFormComponent } from "../../modals/contact-form/contact-form.component";
import { ModalService } from "../../../core/services/modal.service";
import { ViewportDirective } from "../../../core/directives/viewport.directive";
import { NgbProgressbar } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-consultancy-head",
  standalone: true,
  imports: [CardComponent, CommonModule, ViewportDirective, NgbProgressbar],
  templateUrl: "./consultancy-head.component.html",
  styleUrl: "./consultancy-head.component.scss",
})
export class ConsultancyHeadComponent implements OnDestroy {
  private ngZone: NgZone = inject(NgZone);
  @Input() isFromConsultancyPage?: boolean = false;
  cardArr: any[] = [...CONSULTANCY_CARD_ARRAY];
  selectedCard: any = this.cardArr[0];
  currentCardIndex: number = 0;
  hoverCardIndex: number = -1;
  showCard: boolean = false;
  intervalId: any;
  progressValue: any = 0;
  private modalService = inject(ModalService);
  private screenSizeService = inject(ScreenSizeService);
  isSmallScreen$ = this.screenSizeService.isSmallScreen$;
  private progressTimeoutId: any;
  private progressIntervalId: any;
  private isFirstTimeInViewPort: boolean = true;
  isChromeTabChanged: boolean = false;

  @HostListener("document:visibilitychange", ["$event"])
  onVisibilityChange(event: Event): void {
    if (document.hidden) {
      if (!this.isFirstTimeInViewPort) {
        this.stopCardCycle();
        this.isChromeTabChanged = false;
      }
    } else {
      if (!this.isFirstTimeInViewPort) {
        this.isChromeTabChanged = true;
        this.startFromCard(this.currentCardIndex);
      }
    }
  }

  ngOnDestroy() {
    this.stopCardCycle();
  }

  openContactModal() {
    this.modalService.show(ContactFormComponent, {}, "lg", true, "form-modal");
  }

  onInViewport(isInViewport: boolean) {
    this.ngZone.run(() => {
      if (isInViewport && this.isFirstTimeInViewPort) {
        this.currentCardIndex = 0;
        this.startCardCycle();
        if (this.isSmallScreen$()) {
          this.setSelectedCard(this.currentCardIndex);
          this.startProgress();
        }
        this.isFirstTimeInViewPort = false;
      }
      /*else {
            this.stopCardCycle();
        }*/
    });
  }

  startCardCycle() {
    this.showCard = true;
    this.intervalId = setInterval(() => {
      this.currentCardIndex = (this.currentCardIndex + 1) % this.cardArr.length;
      if (this.isSmallScreen$()) {
        this.setSelectedCard(this.currentCardIndex);
      }
      this.startProgress();
    },6000);
  }

  stopCardCycle() {
    this.showCard = false;
    clearInterval(this.intervalId);
    clearInterval(this.progressIntervalId);
    clearInterval(this.progressTimeoutId);
  }

  startFromCard(index: number) {
    this.stopCardCycle();
    this.currentCardIndex = index;
    if (this.isSmallScreen$()) {
      this.setSelectedCard(index);
      this.startProgress(true);
    }
    this.startCardCycle();
  }

  startProgress(clickEvent: boolean = false) {
    this.progressValue = 0;
    if (clickEvent) {
      this.progressTimeoutId = setTimeout(() => {
        this.progressIntervalId = this.intervalMethod(clickEvent);
      }, 500);
    } else {
      this.progressIntervalId = this.intervalMethod(clickEvent);
    }
  }

  intervalMethod(clickEvent: boolean) {
    return setInterval(
      () => {
        this.progressValue += 1;
        if (this.progressValue >= 100) {
          clearInterval(this.progressIntervalId);
        }
      },
      clickEvent ? 53.5 : 56.5
    );
  }

  hoverIn(cardIndex: any) {
    if (this.currentCardIndex === cardIndex) {
      return;
    }
    this.hoverCardIndex = cardIndex;
    this.stopCardCycle();
    this.showCard = true;
  }

  hoverOut(cardIndex: any) {
    if (this.currentCardIndex === cardIndex || this.hoverCardIndex === -1) {
      return;
    }
    this.hoverCardIndex = -1;
    this.startFromCard(this.currentCardIndex);
  }

  private setSelectedCard(index: number) {
    this.selectedCard = this.cardArr.find(
      (obj: any, arrIndex) => arrIndex == index
    );
  }
}
